import axios from 'axios';

const axiosOptions = {
  baseURL: process.env.REACT_APP_API_URI,
  timeout: 10000,
};

const trackingAxiosOptions = {
  baseURL: process.env.REACT_APP_API_URI,
};

export const options = axios.create(axiosOptions);
export const trackingAxios = axios.create(trackingAxiosOptions);

export const defaultAxios = () => {
  return {
    post(url: string, condition?: any) {
      return options.post(url, {
        ...condition,
      });
    },
    put(url: string, condition?: any, config?: any) {
      return options.put(
        url,
        {
          ...condition,
        },
        config,
      );
    },
  };
};

export interface IParams {
  trackCd: string;
  transactionNo: string;
  authToken: string;
  condition: {};
}
